import React from 'react';
import {Navigate} from 'react-router';
import {useSelector} from 'react-redux';

function RouteForSuperAdmin({children}) {
  const {userInfo} = useSelector (state => state.auth);
  const {usertype,role} = userInfo;
  return (usertype==="superadmin" || role?.categories?.includes('superadmin')) ? children : <Navigate to="/" />;
}

export default RouteForSuperAdmin;
